// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lang-button {
    width: 50%;
    padding: 10px;
    background-color: #007bff;
    color: #fff;
    border-radius: 4px;
    border: none;
    cursor: pointer;
    margin: 0px;
  }
  
  .lang-button:hover {
    background-color: #0056b3;
  }`, "",{"version":3,"sources":["webpack://./src/components/language_switcher.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".lang-button {\n    width: 50%;\n    padding: 10px;\n    background-color: #007bff;\n    color: #fff;\n    border-radius: 4px;\n    border: none;\n    cursor: pointer;\n    margin: 0px;\n  }\n  \n  .lang-button:hover {\n    background-color: #0056b3;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
